import component from './WallboxesStep.vue';
import { StepDefinition } from '@/interfaces/step-definition';
import { StepId } from '~/consts/assistant-steps';
const config: StepDefinition = {
  component,
  id: StepId.WALLBOXES,
};

export default config;
